<template lang="pug">
v-dialog(
  v-bind="$attrs"
  v-on="$listeners"
  v-model='dialog'
  :max-width='maxWidth'
  :persistent='!dismissible'
  overlay-color="black"
  overlay-opacity="0.60"
  @keydown.esc="tryDismiss()"
  @click:outside="tryDismiss()"
  scrollable)

  v-card(data-track="modal-dialog")
    v-card-title.pb-0
      .d-flex.align-center( style="width: 100%;" )
        b.text-h5.text-truncate.mr-auto( data-track="modal-dialog-title" ) {{ _title }}
        v-chip.ml-2( small outlined v-if="beta" data-track="modal-dialog-beta-chip" ) {{ $t('common.words.beta') }}
        v-spacer
        v-btn.mr-n2(
          v-if="dismissible"
          @click="closeDialog"
          icon
          data-track="modal-dialog-dismiss-button"
        )
          v-icon icon-dismiss

      .d-flex.align-center( v-if="_subtitle" style="width: 100%;" )
        span.grey--text.text-truncate.mr-auto( data-track="modal-dialog-sub-title" ) {{ _subtitle }}

    v-card-text.py-4( data-track="modal-dialog-body" )
      slot( name="body" )

    v-card-actions.py-5.px-6
      v-spacer
      slot( name="pre-actions" )
      v-btn.mr-3(
        v-if="!disableCancel && dismissible"
        :color="cancelButtonColor"
        :class="cancelButtonClass"
        :text="cancelButtonIsText"
        :outlined="cancelButtonOutlined" @click='closeDialog' data-track="modal-close-button") {{ $t('common.words.cancel') }}
      slot( name="actions" )

</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ModalDialog extends Vue {
  @Prop({ type: Boolean }) readonly disableCancel!: boolean;

  @Prop({ type: Boolean, default: true }) readonly dismissible!: boolean;

  @Prop({ type: Boolean, default: false }) readonly beta!: boolean;

  @Prop({ type: String, default: '600px' }) readonly width!: string;

  dialog = false;

  get _title() {
    return this.$slots?.title || this.$attrs?.title || 'Modal Dialog';
  }

  get _subtitle() {
    return this.$attrs?.subtitle;
  }

  get maxWidth() {
    return 'full' in this.$attrs ? undefined : this.width;
  }

  get cancelButtonColor() {
    return this.$slots?.actions ? 'secondary' : 'primary';
  }

  get cancelButtonOutlined() {
    return !!this.$slots?.actions;
  }

  get cancelButtonIsText() {
    return !!this.$slots?.actions;
  }

  get cancelButtonClass() {
    return this.$slots?.actions ? 'custom-secondary' : 'custom-primary';
  }

  openDialog() {
    this.dialog = true;
  }

  tryDismiss() {
    if (!this.dismissible) {
      return;
    }
    this.closeDialog();
  }

  closeDialog() {
    this.dialog = false;
    setTimeout(() => {
      // wait for animation to finish
      this.$emit('close');
    }, 300);
  }
}
</script>
